import React, {memo} from 'react'
import MultiCheckPresenter from './MultiCheckPresenter/index'
import { urlSearchParams } from '@utility/utills';
import cn from 'classnames'
import { LABEL } from '../../../veriables';
import { TouchableButton } from '../../common/Touchable/index';
import { connect } from 'react-redux';
import ReceiptFooter from '../../ReceiptFooter/index';

const CheckPresenter = (props) => {
  const {paymentLandscapeOrientation} = props;
  return (
    <div className='col-12 px-0 h-100'>
      {urlSearchParams('type') !== 'payType'
        ? <MultiCheckPresenter
          setPaymentFlowType={props.setPaymentFlowType}
          setPaymentType={props.setPaymentType}
          paymentType={props.paymentType}
          paymentCheck={props.paymentCheck}
          setCheckAndSeats={props?.setCheckAndSeats}
          serverAppTheme={props?.serverAppTheme}
          navigate={props.navigate}
          location={props.location}
          showCheckSeat={props?.showCheckSeat}
          resetTip={props.resetTip}
          disablePayment={props.disablePayment}
        />
        :
        <>
        <ReceiptFooter/>
         <div className={('mt-2', paymentLandscapeOrientation ? (["28"].includes(urlSearchParams("screenType")) ? 'col-12 px-0 float-right' : 'col-6 px-0 float-right') : 'col-12 px-0')}>
          <TouchableButton
          onClick={(event) => {
            event.preventDefault();
            props.checkPresenterPay();
          }}
            style={{ 
              height: paymentLandscapeOrientation ? '3.5rem' : '4.25rem', 
              fontWeight: 600, 
              fontSize: paymentLandscapeOrientation ? '1.5rem' : '1.75rem',
              backgroundColor: props.serverAppTheme?.secondaryBtn
            }}
            className={cn('col-12 btn44 px-1 text-white btn-ripple od-primary-btn-bg-color od-primary-btn-font-color')}
            rippleEffect={true}
          >
            {props.disablePayment ? LABEL().CHECK_PRESENTER_PAID : LABEL().CHECK_PRESENTER_PAY} {props.currenySymbol}{props.paymentCheck?.unpaidAmount?.toFixed(2)}
          </TouchableButton>
        </div>
        </>
      }
    </div>
  )
}

const mapStateToProps = ({payment}) => ({
  paymentLandscapeOrientation: payment.paymentLandscapeOrientation
});

const MemoizedCheckPresenter = memo(CheckPresenter);

export default connect(mapStateToProps)(CheckPresenter)